import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import OrderpomappingDashboard from '../OrderpomappingDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function OrderpomappingPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < OrderpomappingDashboard />
    )

}